import 'react-app-polyfill/ie9'
import 'es6-shim'
import 'es5-shim'
import 'core-js/es6/map'
import 'core-js/es6/set'
require('weakmap-polyfill')
